import numeral from 'numeral'

export function formatCost(cost: number | null): string {
  return cost
    ? `${numeral(cost).format('0,0').replace(/,/g, ' ')} €`
    : '-'
}
